import Swiper from 'swiper';
import {Autoplay, EffectFade, Navigation, Pagination} from 'swiper/modules';
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {breakpointUp} from '../utils/breakpoints'
import {VideoPlayer} from "../parts/video-player";

gsap.registerPlugin(ScrollTrigger)

let dynamicPinnedSlide = $('.js-dynamic-pinned-horizontal-slide');

let horizontalScrolls = [];
let slider = [];
window.initDynamicPinnedSlides = () => {
  dynamicPinnedSlide.each(function (index) {
    let slide = this
    if (dynamicPinnedSlide.length) {
      $('.dynamic-pinned-slide .swiper-slide').removeAttr('style');
      const clearHorizontalScroll = () => {
        if (horizontalScrolls[index]) {
          ScrollTrigger.getById(`dynamicPinnedSlide${index}`).kill(true);
          horizontalScrolls[index].kill(true);
          horizontalScrolls[index] = null;
        }
      }
      const clearDynamicPinnedSlideCarousel = () => {
        if (slider[index]) {
          slider[index].destroy(true, true); // Destroy Swiper instance
          slider[index] = null; // Set swiper to null
        }
        $(`${slider[index]} .swiper-slide`).removeAttr('style');
      }
      clearHorizontalScroll();
      clearDynamicPinnedSlideCarousel();
      $('.visual-col').css('width', '')



      if ($(window).width() >= 992) {
        $('.visual-col').each(function () {
          if ($(this).hasClass('full-element')) {
            $(this).width($(window).width()-160)
          } else {
            $(this).width($(this).height())
          }
        });
        let scrollBlock = $(slide).find('.swiper-wrapper')
        let slides = scrollBlock.find('.swiper-slide')
        let fullWidth = 0;
        slides.each(function () {
          fullWidth = fullWidth + $(this).width()
        })

        horizontalScrolls[index] = gsap.to(scrollBlock[0], {
          x: -(fullWidth - scrollBlock.width()),
          ease: "none",
          scrollTrigger: {
            id: `dynamicPinnedSlide${index}`,
            trigger: slide,
            pin: true,
            scrub: 1,
            //snap: 1 / (sections.length - 1),
            start: 'top top',
            end: "+=" + fullWidth / 1.5,
            // onUpdate: self => {
            //   texts.each(function (i, el){
            //     let elProcPos = 1 / (texts.length - i) - ( 1 / texts.length / 2.5)
            //     if (elProcPos <= self.progress) $(this).addClass('show')
            //   })
            // }
          }
        })

        // scrolltirgger to stop and start videos in horizontal scroll
        $(slide).find('video').each(function () {
          let video = this
          new VideoPlayer(`.${$(this).attr('id')}`);

          ScrollTrigger.create({
            trigger: video,
            start: 'left 95%',
            end: 'right 5%',
            containerAnimation: horizontalScrolls[index],
            onEnter: () => {
              video.play();
            },
            onLeave: () => {
              video.pause();
            },
            onEnterBack: () => {
              video.play();
            },
            onLeaveBack: () => {
              video.pause();
            }
          });
        })


      } else {

        let sliderEl = $(slide).find('.js-dynamic-pinned-swiper')[0]


        slider[index] = new Swiper(sliderEl, {
          modules: [Autoplay, EffectFade, Navigation, Pagination],
          slidesPerView: 1,
          rewind: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            600: {
              slidesPerView: 2,
            },
          },
          on: {
            // Stop play video on slide change
            afterInit: function () {
              var video = $('.dynamic-pinned-slide .swiper-slide').first().find('video');

              if (video.length) {
                // Check if autoplay is supported and the video is muted
                var autoplaySupported = ('autoplay' in document.createElement('video')) && !navigator.userAgent.match(/(iPad|iPhone|iPod)/g);

                // Check if the video is ready to play
                video.on('canplay', function() {
                  if (autoplaySupported) {
                    // Autoplay the video
                    video[0].play();
                  } else {
                    // Autoplay not supported, show the first frame
                    video[0].pause();
                    video.attr('poster', video.attr('data-img-src'));
                  }
                });

                // Set the video source
                video.find('source').attr('src', video.attr('data-src'));

                // Load the video
                video[0].load();
              }
            },
            slideChange: function () {
              // stop prev slide video and play current left slider video
              $(sliderEl).find('video').each(function (i, el) {
                $(el).find('source').attr('src', '')
                el.pause()
                el.currentTime = 0
              })

              let curSLide = $(slider[0].slides[this.activeIndex])
              let video = curSLide.find('video')

              if ($(window).width() >= 600) {
                if (!curSLide.find('video').length) {
                  curSLide = $(slider[0].slides[this.activeIndex + 1])
                  video = curSLide.find('video')
                }
              }
              if (video.length) {
                video.find('source').attr('src', video.attr('data-img-src'))
                video[0].play()
              }
            },

          },
        });


        let maxHeight = 0;

        $('.js-dynamic-pinned-swiper .swiper-slide').each(function () {
          let slideHeight = $(this).height();
          if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
          }
        });
        $('.js-dynamic-pinned-swiper .swiper-slide').height(maxHeight);

        $(slide).find('video').each(function () {
          new VideoPlayer(`.${$(this).attr('id')}`);
        })

      }


    }

  })

}

initDynamicPinnedSlides();
